import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DocumentVersionViewComponent } from './version-view/version-view.component';
import { UtilitiesModule } from '@fi-app/utilities/utilities.module';
import { DocumentModule } from '@fi-app/document/document.module';
import { MatCardModule } from '@angular/material/card';
import { FormsModule } from '@angular/forms';
import { DocumentVersionComponent } from './document-version.component';
import { FiDocumentVersionListModule } from '@fi-app/document/version-list/version-list.module';

@NgModule({
    imports: [CommonModule, UtilitiesModule, DocumentModule, MatCardModule, FormsModule, FiDocumentVersionListModule],
    declarations: [DocumentVersionComponent, DocumentVersionViewComponent],
})
export class DocumentVersionModule {}
